import { Component, EventEmitter, forwardRef, Output } from '@angular/core';
import { ControlValueAccessor, UntypedFormBuilder, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SubscriptionList } from 'src/app/modules/shared/models/asp.types';
import * as _ from 'lodash';
import { environment } from 'src/app/modules/shared/services/util.service';
import { Brand } from '@signal/asp-data-commons';

@Component({
  selector: 'app-inquiry-vehicle',
  templateUrl: './inquiry-vehicle.component.html',
  styleUrls: ['./inquiry-vehicle.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InquiryVehicleComponent),
    multi: true
  }]
})
export class InquiryVehicleComponent implements ControlValueAccessor {

  @Output() formEdited:EventEmitter<boolean> = new EventEmitter();

  inquiryVehicle: UntypedFormGroup;
  subs: SubscriptionList = {};
  inquiryVehicleCheckBox: any;
  isLexus = environment.brand === Brand.LEXUS.toLocaleLowerCase();

  constructor(private readonly formbuilder: UntypedFormBuilder) { 
    this.inquiryVehicle = this.formbuilder.group({
      vehicleType: this.formbuilder.group({
        new: [false],
        used: [false],
        both: [false]
      }),
      vehiclesOfInterest: this.formbuilder.group({
        carsMinivan: [false],
        trucks: [false],
        crossoversSuv: [false],
        electrified: [false]
      })
    });

    this.subs.formChangeSub = this.inquiryVehicle?.valueChanges.subscribe(value => {
      if(_.isEqual(this.inquiryVehicleCheckBox, value)) {
        return;
      }
      this.inquiryVehicleCheckBox = value;
      this.setCheckBox(this.inquiryVehicleCheckBox);
      this.onChange(this.inquiryVehicleCheckBox);
      this.onTouched();
      this.formEdited.emit(!this.inquiryVehicle.dirty);
    });
  }

  setCheckBox(value) {
    if(value.vehicleType.both && (!value.vehicleType.new && !value.vehicleType.used) ) {
      const updateValue = value;
      updateValue.vehicleType.both = false;
      this.inquiryVehicle.patchValue(updateValue);
    }
    if(value.vehicleType.both && (!value.vehicleType.new && value.vehicleType.used) ) {
      const updateValue = value;
      updateValue.vehicleType.both = false;
      this.inquiryVehicle.patchValue(updateValue);
    }
    if(value.vehicleType.both && (value.vehicleType.new && !value.vehicleType.used) ) {
      const updateValue = value;
      updateValue.vehicleType.both = false;
      this.inquiryVehicle.patchValue(updateValue);
    }
    if(!value.vehicleType.both && (value.vehicleType.new && value.vehicleType.used) ) {
      const updateValue = value;
      updateValue.vehicleType.both = true;
      this.inquiryVehicle.patchValue(updateValue);
    }
  }
  checkUncheckBoth(event: { checked: boolean; }) {
    const value =  _.cloneDeep(this.inquiryVehicle.value);
    if(!event.checked) {
      const updateValue = value;
      updateValue.vehicleType.new = true;
      updateValue.vehicleType.used = true;
      updateValue.vehicleType.both = true;
      this.inquiryVehicle.patchValue(updateValue);
    }
    if(event.checked) {
      const updateValue = value;
      updateValue.vehicleType.new = false;
      updateValue.vehicleType.used = false;
      updateValue.vehicleType.both = false;
      this.inquiryVehicle.patchValue(updateValue);
    }
  }

  get value() {
    return this.inquiryVehicle.value;
  }

  set value(value) {
    this.inquiryVehicle.setValue(value);
  }
  
  onChange = (_value) => { };
  onTouched = () => { };

  writeValue(value: any): void {
    if (value) {
      this.value = value;
    }  
  }
  
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  registerOnChange = (fn: any) => {
    this.onChange = fn;
  }

}
